module.exports = __webpack_public_path__ + "img/amsbannner5.e1dd0476.png";